import styled from "styled-components";
import { colors } from "../../../assets";

export const ClientsDashboardContainer = styled.div`
  .tabs {
    font-size: 18px;
    font-weight: bold;
    color: white;
    width: 100%;

    ul {
      border-bottom: 1px solid ${colors["PR-001-100"]};
      display: flex;
    }

    li {
      text-align: center;
      margin: 0 5px 0 0;
      padding: 0px 20px 0px 20px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      text-transform: uppercase;
      min-width: 210px;
    }
  }

  .tab-selected {
    background: ${colors["PR-001-100"]};
  }

  .tab-not-selected {
    background: #f1f1f1;
    color: ${colors["primaryColor"]};
    font-weight: 400;
  }

  .tab-spinner {
    position: relative;
    height: 60vh;
  }

  .filter-container {
    width: 300px;
    margin: 20px auto;
  }

  .recharts-legend-wrapper {
    li:hover {
      cursor: pointer;
    }
  }
`;

export const TabContainer = styled.div`
  width: 100%;
  margin: 20px 0;
`;

export const ArticleContainer = styled.article`
  width: 100%;
  margin: 20px 0;
`;

export const SectionContainer = styled.section`
  width: 100%;
  margin: 20px 0;
`;

export const chartColors = [
  "#c0ff02",
  "#a07b00",
  "#4f9737",
  "#ff7800",
  "#fa372c",
  "#bc157d",
  "#9568c4",
  "#2a78bb",
  "#63cef2",
  "#ff72c3",
  "#4b0082",
];

export const ratioChartColors = [
  "#c0ff02",
  "#a07b00",
  "#4f9737",
  "#0f3923",
  "#ff7800",
  "#b35c1a",
  "#fa372c",
  "#8e002d",
  "#bc157d",
  "#6f1266",
  "#9568c4",
  "#6b2c9e",
  "#2a78bb",
  "#415b84",
  "#63cef2",
  "#037c6e",
  "#ff72c3",
  "#973d55",
  "#4b0082",
  "#070056",
];
